export default __webpack_public_path__ + "static/media/user_guide1.00d48fc4.png";